var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.265,
    height: 28.265,
    viewBox: "0 0 28.265 28.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "so-phone",
    d: "M29.394,24.26a2.979,2.979,0,0,1-.738,4.747,10.66,10.66,0,0,1-7.739.907c-6.9-1.738-16.83-11.663-18.568-18.568a10.66,10.66,0,0,1,.907-7.739A2.979,2.979,0,0,1,8,2.87L10.95,5.815a2.959,2.959,0,0,1,.629,3.29,5.479,5.479,0,0,1-1.1,1.656C7.111,14.13,18.135,25.155,21.5,21.784a5.479,5.479,0,0,1,1.658-1.1,2.956,2.956,0,0,1,3.29.629Z",
    transform: "translate(-1.998 -2.001)",
    fill: "#2772af"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoPhone);
export default __webpack_public_path__ + "static/media/so-phone.2acf2885cf1fe65552922023a478a90f.svg";
export { ForwardRef as ReactComponent };